import { Component, OnInit } from '@angular/core';
import { faCalendarAlt , faTimes, faToggleOn, faToggleOff} from '@fortawesome/free-solid-svg-icons';
import { isNullOrEmpty, isValidLength } from '../helper/validation';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NewProjectService } from './new-project.service';
import { ProjectService } from '../project/project.service';
import { SharedService } from '../helper/shared/shared.service';
import { UserInfoService } from '../user-info/user-info.service';
import { ProgramSettingsService } from '../program-settings/program-settings.service';
import { CalculateService } from '../helper/calculate/calculate.service';

@Component({
  selector: 'app-new-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss']
})
export class NewProjectComponent implements OnInit {
  selUnit:any;
  selConcUnitID:any;
  selConcUnit: any;
  selUnitName='';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private newProjectservice: NewProjectService,
    private projectService: ProjectService,
    private userInfoService: UserInfoService,
    private sharedService: SharedService,
    public programSettingService: ProgramSettingsService,
    private calculateService: CalculateService,
  ) { }

  faCalendarAlt = faCalendarAlt;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;
  faTimes = faTimes;
  project = {"Name" :"", "ReportDate":Date, "Desc":""};
  projectId = 1;
  error = true;
  path = '';
  unitList = this.programSettingService.unitList;
  concUnitList = this.programSettingService.concUnitList;
  //calculationType = '';   Modified by JW(2022-08-16): select calculation type

  NumberFormat = '';
  autoSaveProject = this.sharedService.autoSaveProject;
  loading = false;

  ngOnInit(){
    var TodaysDate = new Date();
    var yyyy = TodaysDate.getFullYear();
    var mm = TodaysDate.getMonth() + 1;
    var dd = TodaysDate.getDate();
    let tmpDate:any={
      "day":dd,
      "month":mm,
      "year":yyyy
    }
    this.project = {"Name":"",
                    "ReportDate":tmpDate,
                    "Desc":""
                  };
    this.sharedService.calculationType = "CLD";    //Modified by JW(2022-08-16): select calculation type
    const userId = this.userInfoService.userData.UserId;

    this.sharedService.FromProgramSettings=false;
    this.sharedService.UserInfoMode=false;

    if(userId === 0){
      this.userInfoService.getUserAccountInfo(this.sharedService.token).subscribe((response) => {
        if(response !== undefined && response !== null){
          this.userInfoService.InsertUserData(response);
          this.sharedService.RetrieveDDL();
          this.selUnit = this.userInfoService.userData.UserUnitId;
          this.selUnitName = this.userInfoService.userData.UserUnitName;
          this.selConcUnitID = this.userInfoService.userData.UserConcUnitId;
          this.selConcUnit = this.userInfoService.userData.UserConcUnit;
        } else { //Modified by PP(2023-10-24): Check for timeout of logincode
          this.sharedService.redirectToLoginPage();
          // this.userInfoService.userData.UserId = 0;
          // this.toastr.error('Session time out. Please login again.', '');
          // this.router.navigate(["login"]); 
        }
      });
    } else {
      this.selUnit = this.userInfoService.userData.UserUnitId;
      this.selUnitName = this.userInfoService.userData.UserUnitName;
      this.selConcUnitID = this.userInfoService.userData.UserConcUnitId;
      this.selConcUnit = this.userInfoService.userData.UserConcUnit;
    }

    if(this.selUnit !== 0 && (this.unitList===undefined || this.concUnitList===undefined)) {
      console.log("PS20230321 Check: => fetch program settings -START=> "   + new Date());
      this.programSettingService.getData(this.selUnit).subscribe((result) => {
        console.log("PS20230321 Check: => fetch program settings -END=> "   + new Date());
        if (result !== null) {
          if(result!==undefined){
            this.unitList = result.Selection.UnitsList;
            this.programSettingService.unitList = this.unitList;
  
            //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - START
            //this.concUnitList = result.Selection.ConcentrationUnitList;
            //this.programSettingService.concUnitList = this.concUnitList;
  
            this.programSettingService.airFlowUnit_SI = result.Selection.FlowRateList_SI;
            this.programSettingService.airFlowUnit_US = result.Selection.FlowRateList_US;
            this.programSettingService.concUnit_SI = result.Selection.ConcentrationUnitList_SI;
            this.programSettingService.concUnit_US = result.Selection.ConcentrationUnitList_US;
  
            switch(this.selUnit) { // why no air flow? check with jw
              case 1:
                this.concUnitList = result.Selection.ConcentrationUnitList_SI.List;
                //this.programSettingService.concUnitList = result.Selection.ConcentrationUnitList_SI.List;
                if (this.selConcUnit == "" || this.selConcUnit == null) {
                  this.selConcUnit = result.Selection.ConcentrationUnitList_SI.List.DefaultValue;
                }
                break;
  
              case 2:
                this.concUnitList = result.Selection.ConcentrationUnitList_US.List;
                //this.programSettingService.concUnitList = result.Selection.ConcentrationUnitList_US.List;
                if (this.selConcUnit == "" || this.selConcUnit == null) {
                  this.selConcUnit = result.Selection.ConcentrationUnitList_US.List.DefaultValue;
                }
                break;
            }
            //Modified by PP(2022-08-12-) : Bugs. Left out Airflow units and concentration units in different metrics (SI/US) - END
          }
        } else {
          this.sharedService.redirectToLoginPage();
        }    
      });
    }
    this.projectService.listData = this.sharedService.listData;
    this.projectService.projectdetails = this.projectService.getNewProjectDetails();
    this.sharedService.calculationType = 'CLD';

    //Modified by PP(2023-04-05) : If default Airflow unit not same as userinfo airflow unit - START
    if (this.userInfoService.userData.NumberFormatId === 1) {
      this.NumberFormat = 'sv-SE';
    } else if (this.userInfoService.userData.NumberFormatId === 2) {
      this.NumberFormat = 'en-US';
    }

    let DefaultAirFlowUnitForSIUS = '';
    switch(this.userInfoService.userData.UserUnitId) {
      case 1:
        DefaultAirFlowUnitForSIUS = this.projectService.listData.SI_List.AirFlowUnits.DefaultValue;
        break;
      case 2:
        DefaultAirFlowUnitForSIUS = this.projectService.listData.US_List.AirFlowUnits.DefaultValue;
        break;
    }

    if (this.userInfoService.userData.AirFlowUnit != DefaultAirFlowUnitForSIUS) {
      let convertedAirflow = this.calculateService.ConvertAirFlow(this.sharedService.convertLocaletoNumber(this.projectService.projectdetails.contamination.airflow, this.NumberFormat), DefaultAirFlowUnitForSIUS, this.userInfoService.userData.AirFlowUnit);
      this.projectService.projectdetails.contamination.airflow = convertedAirflow;
    } else {
      this.projectService.projectdetails.airflow = 0; //Put zero so that contamination page will take default value from datalist
    }
    //Modified by PP(2023-04-05) : If default Airflow unit not same as userinfo airflow unit - END

  }

  skipName(){
    this.project.Name = 'Untitled Project '+ this.projectId;
    this.save();
  }

  save(){
    if(isNullOrEmpty(this.project.Name)){
      this.error = true;
      this.toastr.warning('Please fill in the project name', '');
    }
    if(!isValidLength(3, 150, this.project.Name)){
      this.toastr.warning('The project name must contain at least 3 characters (max 150)', '');
    }
    else{
      this.error =false;
    }
    if(!this.error){
      let prjInfo = {
        id : 0,
        folderId: 0,
        calculationType: this.sharedService.calculationType,
        projectDate : this.sharedService.formatDateObjTostring("Object",this.project.ReportDate),
        projectName : this.project.Name,
        projectDesc : this.project.Desc,
        unitId : this.selUnit,
        unitName: this.selUnitName,
        concUnitId: this.selConcUnitID,
        concUnit : this.selConcUnit,
      };

      this.projectService.projectdetails.projectInfo = prjInfo;
      this.sharedService.headerProjectName = this.projectService.projectdetails.projectInfo.projectName;
      this.sharedService.blnCreateNewProject = true;
      //this.sharedService.projectEditName = this.projectService.projectdetails.projectInfo.projectName;  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
      this.sharedService.headerProjectName = this.projectService.projectdetails.projectInfo.projectName;  //Modified by JW(2023-06-06):change Save / Save As messages (follow CREO4 RNDS116 Log#57)
      this.router.navigate(['/project',0], { queryParams: { path  : this.path}});
    }
  }

  close(){
    this.router.navigate(['home']);
  }

  validateSpecialChar(event: any){
    var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(event.key)) {
      this.toastr.warning('Invalid character - you may not use certain characters here','');
      return false;
    } else {
      return true;
    }
  }

  toggleUnit() {}

  toggleConcentration() {
    if (this.selConcUnitID === 1) {
      this.selConcUnitID = 2;
    }else {
      this.selConcUnitID = 1;
    }
  }

  selectCalcType(pType) {
    //Modified by JW(2022-08-16): select calculation type-start
    this.sharedService.calculationType = pType;

    let eleCLD = document.getElementById('btnCLD');
    let eleASTM = document.getElementById('btnASTM');
    if (pType === "CLD") {
      eleCLD.className = 'selectedcalctype-btn';
      eleASTM.className = 'unselectedcalctype-btn';
    }else{
      eleCLD.className = 'unselectedcalctype-btn';
      eleASTM.className = 'selectedcalctype-btn';
    }
    //Modified by JW(2022-08-16): select calculation type-end
  }

  restoreLastProject(){
    console.log("this.autoSaveProject =>");
    console.log(this.autoSaveProject);
    if (this.autoSaveProject !== undefined){
      let selected =this.autoSaveProject;
      if (selected.Path !== '' && selected.Path !== undefined) {
        let  pathString="";
        let pFolder = selected.Path.split('\\');
        if (pFolder.length > 0){
          pathString = '';
          for (let i=0; i<pFolder.length; i++) {
            if (pFolder[i]!==''){
              pathString += pFolder[i]+'/';
            }
          }
        }
        this.sharedService.ProjectToEdit = {
          id:selected.ID,
          name:selected.Fname
        }

        //this.homeComponent.editProject(selected.ID);
        //this.router.navigate(['/projectedit',selected.ID], { queryParams: { path  : pathString}});
        this.loading = true;
        this.projectService.callLoadProjectApi(selected.ID,true).subscribe(
          data => {
            if (data !== null) {
              if (data) {
                var loadFromDB:any = data;
                if (loadFromDB.Process.Fail == false) {
                  this.userInfoService.updateUserApplicationUsage(this.sharedService.token, 'LOADCALCULATION').subscribe(result => {                       
                    if (result) {}
                  });
                  this.sharedService.loadFromDatabase = data;
                  this.toastr.success('Project Loaded successfully', '');
                  this.sharedService.blnLoadFromRecord = true;
  
                  if (loadFromDB.Params.ExportType == 'Incomplete') {
                    this.sharedService.projectNotCalc = true;
                  } else {
                    this.sharedService.projectNotCalc = false;
                  }
                  //this.getProgramSettingsData(); //Modified by PP(2023-02-14) : If Load Project, unit in contamination page:Program Settings is missing
                  this.sharedService.calculationType = loadFromDB.Params.CalcType; //ASTM or CLD
                  this.projectService.projectdetails.NewPath = '';
                  this.sharedService.headerProjectName = loadFromDB.Params.ProjectInfo.ProjectName;
                  this.router.navigate(['/projectedit',selected.ID], { queryParams: { path  : pathString}});
                } else {
                  if (loadFromDB.Process.Message != '') {
                    this.sharedService.blnLoadFromRecord = false;
                    this.loading = false;
                    this.toastr.warning(loadFromDB.Process.Message, '');
                  } else {
                    this.sharedService.blnLoadFromRecord = false;
                    this.loading = false;
                    this.toastr.warning('Something went wrong during loading of project', '');
                  }
                }
              }
            } else {
              this.sharedService.redirectToLoginPage();
            }          
          },
          err =>{
            this.sharedService.blnLoadFromRecord = false;
            this.loading = false;
          }
        );
      }
    }
  }

}
